$('section.collection_tabs .tab_data').slick({infinite:!0,slidesToShow:4,slidesToScroll:1,arrows:!1,autoplay:!1,arrows:!0,prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",autoplaySpeed:2000,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:1,},},{breakpoint:767,settings:{slidesToShow:1,dots:!0,slidesToScroll:1,centerMode:!0,centerPadding:'60px',},},],});$(".tm_cont").slick({slidesToShow:3,infinite:!0,slidesToScroll:1,autoplay:!0,autoplaySpeed:5000,nextArrow:'<button type="button" class="btn1 next-arrow"><img src="https://cdn.shopify.com/s/files/1/0673/9289/7213/files/next.svg?v=1731048257"></button>',prevArrow:'<button type="button" class="btn2 prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0673/9289/7213/files/prev.svg?v=1731048258"></button>',responsive:[{breakpoint:768,settings:{slidesToShow:1,arrows:!1,dots:!0,}}]});if(window.location.href.includes("/pages/how-can-we-help?contact_posted=true")){window.location.href="/pages/thank-you"}
$('.Youtube-videos').slick({infinite:!0,slidesToShow:4,slidesToScroll:1,arrows:!1,autoplay:!1,arrows:!0,autoplaySpeed:2000,responsive:[{breakpoint:2520,settings:{slidesToShow:5,slidesToScroll:1,},},{breakpoint:1920,settings:{slidesToShow:4,slidesToScroll:1,},},{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:1,},},{breakpoint:767,settings:{slidesToShow:1,slidesToScroll:1,},},],})

function updateSwiperStyles() {
    const isNightMode = document.body.classList.contains("night");
    const swiperContainer = document.querySelector("swiper-container")?.shadowRoot;

    if (swiperContainer) {
        const scrollbar = swiperContainer.querySelector(".swiper-scrollbar");
        const scrollbarDrag = swiperContainer.querySelector(".swiper-scrollbar-drag");

        if (scrollbar) {
            scrollbar.style.background = isNightMode ? "rgba(255, 255, 255, 0.5)" : "";
        }

        if (scrollbarDrag) {
            scrollbarDrag.style.background = isNightMode ? "white" : "";
        }
    }
}
const observer = new MutationObserver(updateSwiperStyles);
observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
updateSwiperStyles();
  let megaMenuItems = document.querySelectorAll("details.mega-menu");

megaMenuItems.forEach(item => {
  let menuItem = item.querySelector(".header__menu-item");

  item.addEventListener("mouseenter", () => {
    if (menuItem) {
      menuItem.setAttribute("aria-expanded", "true");
    }
    item.setAttribute("open", "");
  });

  item.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!item.matches(":hover")) {
        if (menuItem) {
          menuItem.setAttribute("aria-expanded", "false");
        }
        item.removeAttribute("open");
      }
    }, 200); 
  });
});